export { default } from './AccordionDetails';